import React from 'react';
import { 
  Truck, Plane, Ship, Package, MapPin, 
  Clock, DollarSign, Users, Globe 
} from 'lucide-react';
import Hero from './components/Hero';
import { ServiceCard, FeatureCard, TestimonialCard } from './components/Cards';

const App = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Hero />

      {/* Mission Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 animate-fadeIn">
          <h2 className="text-3xl font-bold text-center mb-8 text-gray-800">Our Mission</h2>
          <p className="text-lg text-center max-w-3xl mx-auto text-gray-600">
            We provide affordable, efficient, and seamless cargo services, bridging the gap between countries. 
            Our vision is to become the most reliable logistics partner for businesses and individuals, 
            ensuring customer satisfaction and growth.
          </p>
        </div>
      </section>

      {/* Services Section */}
      <section className="py-16 bg-secondary">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Our Services</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <ServiceCard 
              icon={<Globe className="w-8 h-8" />}
              title="International Cargo"
              description="Specialized transport from South Korea to Sri Lanka and beyond."
            />
         <ServiceCard 
              icon={<Truck className="w-8 h-8" />}
              title="Door-to-Door Delivery"
              description="Understanding the need for convenience, Lakjaya Cargo offers door-to-door services, ensuring goods are picked up from the sender and delivered directly to the recipient."
            />
            <ServiceCard 
              icon={<Ship className="w-8 h-8" />}
              title="Sea Freight"
              description="Cost-effective solutions for larger shipments."
            />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Why Choose Us</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <FeatureCard 
              icon={<Clock />}
              title="Reliability"
              description="Trusted by thousands for dependable service."
            />
            <FeatureCard 
              icon={<DollarSign />}
              title="Affordable"
              description="Competitive rates for quality service."
            />
            <FeatureCard 
              icon={<Users />}
              title="Expert Team"
              description="Skilled professionals at your service."
            />
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-16 bg-secondary">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-800">Customer Testimonials</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <TestimonialCard 
              text="I've been using Lakjaya Cargo for years, and their service is unmatched!"
              author="Satisfied Customer"
            />
            <TestimonialCard 
              text="Their door-to-door service makes shipping so convenient."
              author="Happy Client"
            />
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-primary text-gray-800 py-12">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="animate-fadeIn">
              <h3 className="text-xl font-bold mb-4">Lakjaya Cargo Service</h3>
              <p>Delivering Excellence Across Borders</p>
            </div>
            <div className="animate-fadeIn animation-delay-200">
              <h3 className="text-xl font-bold mb-4">Contact Us</h3>
              <p>24/7 Customer Support</p>
              <p>010-25034847</p>
              <p>Email: info@lakjayacargo.com</p>
            </div>
            <div className="animate-fadeIn animation-delay-400">
              <h3 className="text-xl font-bold mb-4">Follow Us</h3>
              <p>4,000+ followers on Facebook</p>
            </div>
          </div>
          <div className="mt-8 pt-8 border-t border-yellow-600 text-center">
            <p>&copy; 2024 Lakjaya Cargo Service. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;